import { memo, useCallback } from "react";
import { classNames, stripHtml, useTranslate } from "helpers";
import { NotificationInboxItemRowProps } from "./types";

/** Koliko je vremena prošlo, u kratkom obliku — popis je uzak, pa nema mjesta za datum. */
const useTimeAgo = () => {
  const { t } = useTranslate();

  return useCallback(
    (dateStr: string) => {
      const minutes = Math.floor((Date.now() - new Date(dateStr).getTime()) / 60000);

      if (minutes < 1) return t("admin.notification.inbox.justNow");
      if (minutes < 60) return `${minutes} min`;

      const hours = Math.floor(minutes / 60);
      if (hours < 24) return `${hours}h`;

      return `${Math.floor(hours / 24)}d`;
    },
    [t]
  );
};

const NotificationInboxItemRow: React.FC<NotificationInboxItemRowProps> = ({
  item,
  onClick,
}) => {
  const formatTimeAgo = useTimeAgo();

  const handleClick = useCallback(() => onClick(item.id), [item.id, onClick]);

  return (
    <div
      onClick={handleClick}
      className={classNames(
        "px-4 py-3 border-b cursor-pointer hover:bg-gray-50 transition-colors",
        item.isRead ? "bg-white" : "bg-blue-50"
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-start gap-2 min-w-0">
          {/* Točka uz nepročitano: sama podloga se lako previdi kad je popis dug. */}
          <span
            className={classNames(
              "w-1.5 h-1.5 rounded-full mt-1.5 shrink-0",
              item.isRead ? "bg-transparent" : "bg-blue-500"
            )}
          />
          <p className="text-sm font-medium text-gray-800 truncate">{item.sentTitle}</p>
        </div>
        <span className="text-xs text-gray-400 whitespace-nowrap">
          {formatTimeAgo(item.created)}
        </span>
      </div>

      {/* Poruka nosi HTML iz predloška ({{EntityName}} se umeće u <strong>), a ovdje se
          prikazuje kao čisti tekst — isto kao u koloni "Poruka" na pretrazi. */}
      <p className="text-xs text-gray-500 mt-0.5 line-clamp-2 pl-3.5">
        {stripHtml(item.sentMessage)}
      </p>
      {item.entityDisplayName && (
        <p className="text-xs text-gray-400 mt-0.5 pl-3.5">{item.entityDisplayName}</p>
      )}
    </div>
  );
};

export { NotificationInboxItemRow };
export default memo(NotificationInboxItemRow);
